var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a',{attrs:{"href":_setup.fileLink,"title":_setup.linkTitle,"target":"_blank"}},[_vm._v(_vm._s(_setup.linkLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }